import React from 'react';

const MedicalStaffSection = ({ formData, handleChange }) => {
  return (
    <div className="border-2 border-teal-200 rounded-xl p-4 bg-gradient-to-br from-teal-50 to-white shadow-sm">
      <h3 className="text-lg font-bold mb-4 text-teal-800 flex items-center">
        <div className="w-2 h-6 bg-teal-600 rounded-full mr-3"></div>
        Medical Staff
      </h3>
      <div className="space-y-3">
        {[
          { key: "anaesthetist1", label: "Primary Anesthetist" },
          { key: "anaesthetist2", label: "Assistant Anesthetist" },
          { key: "surgeon1", label: "Primary Surgeon" },
          { key: "surgeon2", label: "Assistant Surgeon" },
        ].map(({ key, label }) => (
          <div key={key}>
            <label className="block text-sm font-semibold mb-2 text-gray-700">
              {label}
              {(key === "anaesthetist1" || key === "surgeon1") && <span className="text-red-500 ml-1">*</span>}
            </label>
            <input
              type="text"
              value={formData[key] || ''}
              onChange={handleChange(key)}
              placeholder={`Dr. ${label.split(" ")[1]} Name`}
              className="border-2 border-gray-300 px-3 py-2 w-full rounded-lg text-sm focus:border-teal-500 focus:outline-none transition-colors"
              aria-label={label}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default MedicalStaffSection;
